export default "__VITE_ASSET__2fc95aef__"